import React, { useState } from 'react'
import SecondaryButton from '../common/buttons/SecondaryButton'
import { useSelector } from 'react-redux';
import { ENDPOINTS } from '../../js/api/_config';
import axios from 'axios';



const RerouteModel = ({ patientName, trialName, patientTrialJuncID, patientID ,addToast,handleReRouteModalOpen,OnSuccess}) => {

    const trailData = useSelector((state) => state.trails_name.data);
    const trailDataList = trailData ? trailData.filter((trail) => trail.trialName != trialName) : [];

    const [rerouteReason, setRerouteReason] = useState("");
    const [error, setError] = useState({});
    const [selectedTrailsName, setSelectedTrailsName] = useState(trialName);
    const [selectedTrailsNameId, setSelectedTrailsNameId] = useState(null);

    const handleSelectChange = (e) => {
        const selectedName = e.target.value;
        setSelectedTrailsName(selectedName);
        const selectedTrailNames = trailData.find(
            (tz) => tz.trialName === selectedName
        );

        setSelectedTrailsNameId(selectedTrailNames.trialID);
        console.log("Selected Trail ID:", selectedTrailNames.trialID);
    };

    const handleReasonChange = (e) => {
        if (e.target.value.length <= 500) {
            setRerouteReason(e.target.value);
        }
    };

    const onReRoute = async () => {

        if (!selectedTrailsNameId) {
            addToast("Please select a trial","error");
            return;
        }

        const requestBody = {
            trialID: selectedTrailsNameId,
            patientTrialJuncID: patientTrialJuncID,
            patientID: patientID,
            reRouteReason: rerouteReason,
        };

        try {
            const response = await axios.put(ENDPOINTS.TRIALS.REROUTE, requestBody);
            if (response.status === 200) {
                handleReRouteModalOpen(false);
                addToast("Trial status rerouted successfully", "success");
                if(OnSuccess) OnSuccess();
                return response.data;
            } else {
                addToast("Failed to rerouting trial status", "error");
            }
        } catch (error) {
            const message = error?.response?.data?.message;

            if (message) {
                addToast(error.response.data.message, "error");
                return;
            }

            const error_res = error.response?.data?.errors || {};
            if (error_res) {
                const firstKey = Object.keys(error_res)[0];
                const message = error_res[firstKey][0];
                addToast(message, "error");
                return;
            }

            addToast("Error in rerouting trial status:", "error");
        }
    };


return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
            <div>
                <div>
                    <label for="timezone" class="block form_label_color">
                        Select a Trials to Reroute {patientName}
                    </label>
                    <div className="flex  mt-2 text-sm items-center relative">
                        <select
                            id="trailsName"
                            name="trailsName"
                            value={selectedTrailsName}
                            className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                            onChange={handleSelectChange}
                        >
                            <option value={""} selected>
                                Select Trial
                            </option>
                            {trailDataList &&
                                trailDataList.length > 0 &&
                                trailDataList.map((tz) => (
                                    <option key={tz.trialID} value={tz.trialName}>
                                        {tz.trialName}
                                    </option>
                                ))}
                        </select>
                        <span className="absolute right-4 top-[25px] transform -translate-y-1/2 pointer-events-none">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                                    stroke="#245CEA"
                                    strokeWidth="2"
                                    stroke-miterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                </div>

                <textarea
                    className="field_bg border_color border text-base rounded-lg block w-full p-2.5 mt-5 h-40"
                    value={rerouteReason}
                    onChange={(e) => handleReasonChange(e)}
                    placeholder="Type your Reason here..."
                ></textarea>

                <div className="flex justify-between items-center mt-2">
                    <div>
                        {error.rerouteReason && (
                            <p className="text-[#F95454] font-mont text-[14px] font-[500]">
                                {error.rerouteReason}
                            </p>
                        )}
                    </div>

                    <div className="text-sm text-gray-600">
                        {rerouteReason.length} / 500
                    </div>
                </div>

                <div className="flex flex-row justify-end gap-5 mt-5">
                    <button
                        className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500"
                        onClick={() => {
                            onReRoute();
                        }}
                    >
                        Reroute
                    </button>
                    <SecondaryButton
                        onClick={()=>{handleReRouteModalOpen(false)}}
                        label="Cancel"
                        classes={"px-5 py-3"}
                    />
                </div>
            </div>
        </div>
    </div>
)
}

export default RerouteModel